import React from 'react'
import Row from 'react-bootstrap/Row'
import Select, { components } from 'react-select'
import up from '../assets/up.png'
import down from '../assets/down.png'
import downArrow from '../assets/down_arrow.png'

const ValueContainer = ({ children, ...props }) => {
  return (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        {!!children && (
          <div className='category'>Category: </div>
        )}
        {children}
      </components.ValueContainer>
    )
  )
}

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <img src={downArrow} style={{height: 25 * 0.75, marginTop: 1}} alt=""/>
      </components.DropdownIndicator>
    )
  )
}

const customStyles = {
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menu: (provided, state) => ({
    ...provided,
    textTransform: 'uppercase',
    fontSize: '0.9rem',
    letterSpacing: '0.07em',
    fontFamily: 'Inter',
    fontWeight: 'bold',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen ? 'black' : 'white',
    textTransform: 'uppercase',
    fontSize: '1rem',
    letterSpacing: '0.07em',
    fontFamily: 'Inter',
    fontWeight: 'bold',
    paddingLeft: 122,
  }),
  input: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen ? 'black' : 'white',
    textTransform: 'uppercase',
    fontSize: '0.9rem',
    letterSpacing: '0.07em',
    fontFamily: 'Inter',
    fontWeight: 'bold',
    paddingLeft: 122,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    '&:hover': {
      cursor: 'text',
    }
  }),
  control: (provided, state) => ({
    ...provided,
    //backgroundColor: state.isFocused ? 'white' : '#AEC4FF',
    backgroundColor: '#AEC4FF',
    border: 'none',
    borderRadius: 7.5,
    boxShadow: state.isFocused ? 'none' : 'none',
    display: 'flex',
    justifyContent: 'center',
    height: 44,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    '&:hover': {
      cursor: 'pointer',
      color: state.menuIsOpen ? 'black' : 'white',
    }
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'rgb(80, 115, 249)' : null,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: state.isSelected ? 'rgb(80, 115, 249)' : 'rgb(214, 230, 255)',
    }
  }),
  container: (provided, state) => ({
    ...provided,
    height: 44
  }),
  
}

export class Buttons extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  createOption = cat => {
    return { value: cat, label: cat }
  }

  render() {
    return (
      <Row className='buttons-row'>
        <div className='select-div'>
          <Select
            value={this.props.category}
            onChange={(selectedOption) => this.props.changeCategory(selectedOption)}
            options={this.props.categories.map(cat => this.createOption(cat))}
            styles={customStyles}
            components={{ ValueContainer, DropdownIndicator }}
          />
        </div>
        <div 
          className={this.props.trendDir === 'up' ? 'button first active' : 'button first inactive'}
          onClick={() => this.props.changeDir('up')}
        >
          <span><img src={up} className='arrow' alt=""/></span>
        </div>
        <div 
          className={this.props.trendDir === 'down' ? 'button second active' : 'button second inactive'}
          onClick={() => this.props.changeDir('down')}
        >
          <span><img src={down} className='arrow' alt=""/></span>
        </div>
      </Row>
    )
  }
}
